import styled from 'styled-components';

import { breakpoints } from '@soluto-private/mx-asurion-ui-react';

const LeftMainContentSectionStyled = styled.div`
  padding: 16px 16px 34px 16px;

  ${breakpoints.md} {
    padding: var(--pageLayoutPadding, 24px);
    height: 100%;
    overflow-y: auto;
  }

  ${breakpoints.lg} {
    padding: var(--pageLayoutPadding, 48px);
  }
`;

export type LeftMainContentSectionProps = {
  children?: React.ReactNode;
};

export const LeftMainContentSection = ({
  children,
}: LeftMainContentSectionProps) => (
  <LeftMainContentSectionStyled tabIndex={0}>
    {children}
  </LeftMainContentSectionStyled>
);
